
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1c76"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1c76"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("l7tRt", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $f6016a4e07941f4c$export$6503ec6e8aabbaf; }, function (v) { return $f6016a4e07941f4c$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $f6016a4e07941f4c$export$f7ad0328861e2f03; }, function (v) { return $f6016a4e07941f4c$export$f7ad0328861e2f03 = v; });
var $f6016a4e07941f4c$export$6503ec6e8aabbaf;
var $f6016a4e07941f4c$export$f7ad0328861e2f03;
"use strict";
var $f6016a4e07941f4c$var$mapping = new Map();
function $f6016a4e07941f4c$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f6016a4e07941f4c$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f6016a4e07941f4c$var$resolve(id) {
    var resolved = $f6016a4e07941f4c$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f6016a4e07941f4c$export$6503ec6e8aabbaf = $f6016a4e07941f4c$var$register;
$f6016a4e07941f4c$export$f7ad0328861e2f03 = $f6016a4e07941f4c$var$resolve;

});

var $2c66aef5f1c66698$exports = {};

(parcelRequire("l7tRt")).register(new URL("", import.meta.url).toString(), JSON.parse('["64oI4","index.c06dc5ba.js","cGMcm","../quill.a6b954e0.js"]'));


//# sourceMappingURL=index.runtime.4cdf3060.js.map
